import { createFileRoute, redirect } from "@tanstack/react-router";
import { tokens } from "@/lib/api";

// A raiz não tem tela própria: quem tem sessão vai para o painel, quem não tem
// vai para o login.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: tokens.access || tokens.refresh ? "/painel" : "/entrar" });
  },
});
